<template>
    <main>
        <admin-nav-menu active-item="contact"></admin-nav-menu>
        контакты
    </main>
</template>

<script>
import AdminNavMenu from './Components/AdminNavMenu.vue';

export default {
        components: {
            AdminNavMenu
        }
    }
</script>
